import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { ITextProps, Text } from "@/components/Text";
import { TaskPriority } from "@/data/tasks";
import { TColorVariant } from "@/style/colorVariants";

export interface ITaskPriorityLabelProps extends ITextProps {
  priority: TaskPriority;
}

export const TaskPriorityLabel: FC<ITaskPriorityLabelProps> = ({ priority, children, ...props }) => {
  const { t } = useTranslation("session");
  const color: TColorVariant = priority === "CRITICAL" ? "error" : priority === "URGENT" ? "warning" : "success";

  return (
    <Text color={color} {...props}>
      {children ? children : t(`TASKS.PRIORITY.${priority}`)}
    </Text>
  );
};
